/* global femcare */

femcare.product.panel.info.shop = {
    $mainPanel: $('.product-main--shop'),
    mediaPanel: null,
    sku: null,
    selectedOptions: {},
    defaultShopItemLimit: 50,
    $counter: null,
    ean: null,
    antiforgeryToken: null,

    init: function () {
        if (this.$mainPanel.length) {
            this.mediaPanel = femcare.product.panel.media;
            this.ean = this.$mainPanel.attr('data-ean');
            this.sku = { skuId: this.$mainPanel.attr('data-initial-sku') };

            this.antiforgeryToken = femcare.product.cart.$cartModal.attr('data-token');
            this.$counter = this.$mainPanel.find('.counter');

            this.mediaPanel.init();
            this.initTooltips();
            this.initCounter();
            this.initAddToCart();
            this.initSkuOptions();
            this.initAddToStash();
            this.initOutOfStockModal();
        }
    },

    initTooltips: function () {
        var $purchase = $('.product-main-purchase');
        var purchaseContent = $purchase.find('.product-main-purchase__tooltip').text().trim();

        $purchase.tooltip({
            items: $purchase,
            content: purchaseContent,
            classes: {
                'ui-tooltip': 'tooltip',
                'ui-tooltip-content': 'tooltip__content'
            }
        });

        var $flowMetrics = $('.product-metric--flow');

        $flowMetrics.each(function (index, element) {
            var $flowMetric = $(element);
            var flowContent = $flowMetric.find('.product-metric-tooltip')[0].outerHTML;

            $flowMetric.tooltip({
                items: $flowMetric,
                content: flowContent,
                classes: {
                    'ui-tooltip': 'tooltip',
                    'ui-tooltip-content': 'tooltip__content'
                }
            });
        });
    },

    initCounter: function () {
        this.$counter.counter({ max: parseInt(this.$counter.attr('data-max'), 10) });
    },

    initSkuOptions: function () {
        var $selectMenuWidgets = $('.product-main-options .form-group--selectmenu select');

        $selectMenuWidgets.each(function (index, element) {
            var $select = $(element);
            this.selectedOptions[$select.attr('id')] = $select.val();

            $select.selectmenu({
                change: function (e, ui) {
                    this.selectedOptions[$select.attr('id')] = ui.item.value;
                    this.loadSku();
                }.bind(this)
            });

        }.bind(this));
    },

    initAddToStash: function () {
        $('.product-stash-add__button').on('click', function () {
            var data = {
                key: femcare.product.stash.key,
                value: {
                    ean: this.ean,
                    variationAttributes: this.getVariationAttributes()
                }
            };

            femcare.shared.ui.setLoadingOverlay(true);

            $.ajax({
                url: femcare.shared.util.baseUrl + 'ajax/products/product/stashToSession',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function (res) {
                    femcare.shared.ui.setLoadingOverlay(false);
                    res.success && this.refreshStashCount();
                }.bind(this),
                error: function () {
                    femcare.shared.ui.setLoadingOverlay(false);
                }
            });

            // $.ajax({
            //     url: '/json/ajax-add-stash.json',
            //     method: 'GET',
            //     success: function (res) {
            //         femcare.shared.ui.setLoadingOverlay(false);
            //         res.success && this.refreshStashCount();
            //     }.bind(this)
            // });

        }.bind(this));
    },

    refreshSku: function (sku) {
        this.updateSkuName(sku.productSkuName);
        this.updateSkuPrice(sku.priceInformation);
        this.updateAddToCart(sku.productQuantity);

        this.replaceSkuSlides(sku);
        this.mediaPanel.init();
    },

    updateSkuName: function (name) {
        this.$mainPanel.find('.product-main__name').text(name);
    },

    updateSkuPrice: function (price) {
        var $strikethroughPrice = this.$mainPanel.find('.product-main-purchase__amount--old');
        var $price = this.$mainPanel.find('.product-main-purchase__amount--new');

        if (price.showDiscount) {
            $strikethroughPrice.text(price.priceWithoutDiscount);
            $strikethroughPrice.show();
            $price.text(price.sellingPrice);
        } else {
            $strikethroughPrice.text('');
            $strikethroughPrice.hide();
            $price.text(price.priceWithoutDiscount);
        }
    },

    initAddToCart: function () {
        var $addToCart = $('.product-cart-add__button');

        $addToCart.on('click', function () {
            var count = this.$counter.counter('getCount');

            var data = {
                ean: this.ean,
                id: this.sku.skuId,
                variationAttributes: this.getVariationAttributes(),
                quantity: count
            };

            // $.ajax({
            //     url: '/json/ajax-add-sku.json',
            //     method: 'GET',
            //     success: function (res) {
            //         if (res.success) {
            //             this.refreshCartCount();
            //             femcare.product.cart.displayAddedNotification(res.product, res.checkoutUrl);
            //         }
            //     }.bind(this)
            // });

            femcare.shared.ui.setLoadingOverlay(true);

            $.ajax({
                url: femcare.shared.util.baseUrl + 'ajax/products/product/addItemToBag',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: { 'RequestVerificationToken': this.antiforgeryToken },
                success: function (res) {
                    if (res.success) {
                        femcare.shared.ui.setLoadingOverlay(false);
                        this.refreshCartCount();
                        femcare.product.cart.displayAddedNotification(res.product, res.checkoutUrl);

                        var variantProductData = 'No variants';
                        if(res.product.variationAttributes){
                            variantProductData = res.product.variationAttributes.map(function (variantAttribute) {
                                return variantAttribute.value
                            }).join();
                        }

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(
                            {
                                event: 'addToCart',
                                ecommerce:
                                {
                                    currencyCode: res.product.priceInformation.currency.code,
                                    add: {
                                        products: [{
                                            name: res.product.name,
                                            id: res.product.productId,
                                            price: res.product.priceInformation.sellingPriceNoFormat,
                                            quantity: res.product.quantity.initial.toString(),
                                            category: res.product.category,
                                            variant: variantProductData
                                        }]
                                    }
                                }
                            });
                    }
                }.bind(this),
                error: function () {
                    femcare.shared.ui.setLoadingOverlay(false);
                }
            });
        }.bind(this));
    },

    refreshCartCount: function () {
        femcare.shared.ui.setLoadingOverlay(true);

        return $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getbag?onlyTotal',
            dataType: 'json',
            method: 'GET',
            headers: { 'RequestVerificationToken': this.antiforgeryToken },
            success: function (res) {
                var cartItemCount = (res && res.totalItems) || 0;
                femcare.shared.pubsub.publish('CART_ITEM_COUNT_UPDATED', cartItemCount);
            },
            complete: function () {
                femcare.shared.ui.setLoadingOverlay(false);
            }
        });
    },

    refreshStashCount: function () {
        femcare.shared.ui.setLoadingOverlay(true);

        return $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getFromSession',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ key: femcare.product.stash.key }),
            success: function (data) {
                var stashItemCount = (data.items && data.items.totalItems) || 0;
                femcare.shared.pubsub.publish('STASH_ITEM_COUNT_UPDATED', stashItemCount);
            },
            complete: function () {
                femcare.shared.ui.setLoadingOverlay(false);
            }
        });

        // $.ajax({
        //     url: '/json/ajax-get-stash.json',
        //     method: 'GET',
        //     success: function (data) {
        //         var stashItemCount = (data.items && data.items.totalItems) || 0;
        //         femcare.shared.pubsub.publish('STASH_ITEM_COUNT_UPDATED', stashItemCount);
        //     }
        // });
    },

    updateAddToCart: function (quantity) {
        var availableQuantity = parseInt(quantity.max, 10);
        this.$mainPanel
            .find('.product-unavailable__message--availability')
            .text(quantity.availability.stockMessage);

        if (availableQuantity > 0) {
            this.$counter.counter('setCount', 1);
            this.$counter.counter('setMax', Math.min(this.defaultShopItemLimit, availableQuantity));
            this.toggleOutOfStockMessage(false);
        } else {
            this.toggleOutOfStockMessage(true);
        }
    },

    toggleOutOfStockMessage: function (show) {
        var $addButton = this.$mainPanel.find('.product-cart-add__button');
        var $counter = this.$mainPanel.find('.product-cart-add__counter');
        var $message = this.$mainPanel.find('.product-unavailable');
        var $stash = this.$mainPanel.find('.product-stash-add');

        if (show) {
            $addButton.hide();
            $counter.hide();
            $stash.hide();
            $message.show();
        } else {
            $addButton.show();
            $counter.show();
            $stash.show();
            $message.hide();
        }
    },

    loadSku: function () {
        var data = {
            ean: this.ean,
            variationAttributes: this.getVariationAttributes()
        };

        femcare.shared.ui.setLoadingOverlay(true);

        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/detailproductsku',
            method: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            headers: { 'RequestVerificationToken': this.antiforgeryToken },
            success: function (res) {
                this.sku = res.product;
                this.refreshSku(this.sku);
            }.bind(this),
            complete: function () {
                femcare.shared.ui.setLoadingOverlay(false);
            }
        });

        // $.ajax({
        //     url: '/json/ajax-load-sku.json',
        //     method: 'GET',
        //     success: function (res) {
        //         this.sku = res.product;
        //         this.refreshSku(this.sku);
        //     }.bind(this)
        // });
    },

    getVariationAttributes: function () {
        var variationAttributes = [];

        for (var key in this.selectedOptions) {
            if (this.selectedOptions.hasOwnProperty(key)) {
                variationAttributes.push({
                    name: key,
                    value: this.selectedOptions[key]
                });
            }
        }

        return variationAttributes;
    },

    replaceSkuSlides: function (sku) {
        var $mainSlides = this.$mainPanel.find('.product-main__slides');
        var $thumbnailSlides = this.$mainPanel.find('.product-main__thumbnails');
        var zoomInAsset = $mainSlides.attr('data-zoom-in');
        var zoomOutAsset = $mainSlides.attr('data-zoom-out');

        this.mediaPanel.thumbnailGallery && this.mediaPanel.thumbnailGallery.destroy();
        this.mediaPanel.thumbnailGallery = null;
        this.mediaPanel.mainGallery && this.mediaPanel.mainGallery.destroy();
        this.mediaPanel.mainGallery = null;

        var $tempMainSlideContainer = $('<div></div>');
        var $tempThumbnailContainer = $('<div></div>');

        sku.images.forEach(function (image) {
            var $mainSlide = $('<div class="product-main__slide swiper-slide"></div>');
            var $zoomContainer = $('<div class="swiper-zoom-container"></div>');
            var $zoomTarget = $('<div class="swiper-zoom-target"></div>');

            var $standardImageWrapper = $('<div class="product-main__image product-main__image--standard"></div>');
            $standardImageWrapper.css('cursor', 'url(' + zoomInAsset + ') 17.5 17.5, pointer');
            var $standardImage = $('<img class="swiper-lazy"/>');
            $standardImage.attr('data-src', image.url);
            $standardImageWrapper.append($standardImage);
            $zoomTarget.append($standardImageWrapper);

            var $largeImageWrapper = $('<div class="product-main__image product-main__image--large"></div>');
            $largeImageWrapper.css('cursor', 'url(' + zoomOutAsset + ') 17.5 17.5, pointer');
            var $largeImage = $('<img class="swiper-lazy"/>');
            $largeImage.attr('data-src', image.url);
            $largeImageWrapper.append($largeImage);
            $zoomTarget.append($largeImageWrapper);

            $zoomContainer.append($zoomTarget);
            $mainSlide.append($zoomContainer);
            $tempMainSlideContainer.append($mainSlide);

            var $thumbnailSlide = $('<li class="product-main__thumbnail swiper-slide"></li>');
            var $thumbnailImage = $('<img src="' + image.url + '"/>');
            $thumbnailSlide.append($thumbnailImage);
            $tempThumbnailContainer.append($thumbnailSlide);
        });

        $mainSlides
            .empty()
            .append($tempMainSlideContainer.html());

        $thumbnailSlides
            .empty()
            .append($tempThumbnailContainer.html());
    },

    initOutOfStockModal: function () {
        var $openButton = this.$mainPanel.find('.product-unavailable__notify-button');
        var $notificationForm = this.$mainPanel.find('.modal-product-unavailable__form');

        $openButton.on('click', function () {
            femcare.shared.util.$modal.genericModal('open', '.product-unavailable__modal-content');
        });

        $notificationForm.on('submit', function (e) {
            e.preventDefault();

            var formData = new FormData($notificationForm[0]);
            var postData = {};

            formData.forEach(function (value, key) {
                postData[key] = value;
            });

            postData.ean = this.ean;
            postData.variationAttributes = this.getVariationAttributes();

            $.ajax({
                url: femcare.shared.util.baseUrl + 'ajax/products/product/notifyMe',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(postData),
                headers: { 'RequestVerificationToken': this.antiforgeryToken },
                success: function (res) {
                    if (res.success) {
                        femcare.shared.util.$modal.genericModal('open', '.product-notify-feedback__modal-content');
                    }
                }
            });
        }.bind(this));
    }
};